export const SET_DATA = 'emails/setData'
export const SET_LOADING = 'emails/setLoading'
export const CLEAR_FILES = 'emails/clearFiles'
export const setData = (payload) => ({ type: SET_DATA, payload })
export const setLoading = (payload) => ({ type: SET_LOADING, payload })
export const clearFiles = () => ({ type: CLEAR_FILES })
export const initialState = {
  data: {
    organizations: [],
    scorecard_config_sid: '',
    emails: [],
    errors: [],
    isUploadComplete: false,
  },
  loading: {
    emailUpload: false,
  },
}

export default function emailsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_DATA:
      return { ...state, data: { ...state.data, ...action.payload } }
    case SET_LOADING:
      return { ...state, loading: { ...state.loading, ...action.payload } }
    case CLEAR_FILES:
      return initialState
    default:
      return state
  }
}
